export const BASE_PRICE_GBP = 29;
export const PER_CLEANER_GBP = 3.79;
export const CURRENCY = "GBP" as const;
export const TRIAL_DURATION_DAYS = 14;

export function computeMonthlyEstimateGbp(cleanerCount: number): number {
  const cleaners = Math.max(0, Math.floor(cleanerCount));
  return BASE_PRICE_GBP + cleaners * PER_CLEANER_GBP;
}

export function formatGbp(amount: number): string {
  const rounded = Math.round(amount * 100) / 100;
  return `£${rounded.toFixed(2)}`;
}
